/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import ViewerControllerIframe from '../controller/viewer-controller-iframe';

/**
 * @import { IViewerSourceCreator, IElement } from '../../iframe'
 * @import { ViewerType } from '../../viewer/type'
 */

// TODO Přejmenovat na WebsiteViewerType, aby se nepletlo s web platformou.
/**
 * Typ média web aplikace.
 * Používá se pouze URL ze serveru bez podpory offline stavu.
 * @implements {ViewerType}
 */
export default class ViewerTypeWeb {
  /**
   * Vytvoří instanci.
   * @param {number} loadDelay
   * @param {IViewerSourceCreator} sourceCreator
   */
  constructor(loadDelay, sourceCreator) {
    this.loadDelay = loadDelay;
    this.sourceCreator = sourceCreator;
  }

  /** @type {ViewerType['createController']} */
  createController(el, communicatorSettingsGetter) {
    return new ViewerControllerIframe(
      /** @type {IElement} */ (el),
      this.loadDelay
    );
  }

  /** @type {ViewerType['getCheckFile']} */
  getCheckFile(medium) {
    // Weby nemají v detailu média nastavení "Kontrolovat aktuální verzi".
    return false;
  }

  /** @type {ViewerType['getSourceCreator']} */
  getSourceCreator() {
    return this.sourceCreator;
  }

  /** @type {ViewerType['getUrl']} */
  getUrl(medium) {
    return Promise.resolve(medium.url);
  }

  /** @type {ViewerType['isExtractable']} */
  isExtractable() {
    return false;
  }

  /** @type {ViewerType['isOfflineable']} */
  isOfflineable() {
    return false;
  }

  /** @type {ViewerType['isPreloadable']} */
  isPreloadable(medium) {
    // U webových stránek se moc nepočítá s tím, že by byly spuštěné na pozadí.
    // Dělá to problémy při naslouchání na události, např. události ovládání.
    // Byl řešen problém s autofocus, který se nechoval při preloadu správně.
    // Také nelze jednoduše vypnout zvuky, které mohou vznikat.
    // Proto je preload zakázaný.
    return false;
  }

  /** @type {ViewerType['isSeekable']} */
  isSeekable(medium) {
    return false;
  }

  /** @type {ViewerType['isStatic']} */
  isStatic(medium) {
    return true;
  }
}
